import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as PrizeItemActions from "../../../store/actions/PrizeItem";
import * as FeatureActions from "../../../store/actions/Feature";
import * as UserActions from "./../../../store/actions/User";
import { getInitialState } from "../../../utils";
import {
  isValidated,
  filterObj,
  getReadableDateTime,
  getSortedList,
} from "../../../utils";
import Permission from "../../Common/Permission";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import NoFooterModal from "../../Common/NoFooterModal";
import Input from "sushiweb/InputTypes/Input";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import { BottomSectionModal } from "../../../constants/assets/containers";
import Button from "sushiweb/Button";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import _ from "lodash-es";

const mandatoryFields = [
  "name",
  "category",
  "status",
  "validity",
  "created_at",
  "updated_at",
  "info",
  "item_image",
  "win_greet_image",
  "wheel_image",
];

const statusOptions = [
  { key: "inactive", label: "inactive" },
  { key: "active", label: "active" },
];

const categoryOptions = [
  { key: "major", label: "major" },
  { key: "medium", label: "medium" },
  { key: "minor", label: "minor" },
  { key: "nothing", label: "nothing" },
];

export const PrizeItemFormModal = (props) => {
  const {
    modalState,
    handleClose,
    activeItem,
    activePrizeItem,
    activeFilters,
    filterFields,
    currentPage,
    setStatus,
    setActivePrizeItem,
    resetState,
  } = props;
  const allActions = MenuActionsMappings[MenuNames.PRIZE_ITEMS];
  const [initialState, setInitialState] = useState({
    id: activePrizeItem.id,
    name: "",
    category: "",
    status: "",
    setConditions: true,
    validity: 0,
    created_at: "",
    updated_at: "",
    item_image: "",
    wheel_image: "",
    win_greet_image: "",
    info: "",
  });
  const [ImagemodalOpen, setImageModalOpen] = useState(false);
  const [activeImage, setActiveImage] = useState("");
  const [activeImageheading, setActiveImageHeading] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    const body = filterObj(initialState, [
      "id",
      "name",
      "category",
      "status",
      "validity",
      "created_at",
      "updated_at",
      "info",
      "item_image",
      "win_greet_image",
      "wheel_image",
    ]);
    //if filter button is clicked then apply filters
    if (modalState === "Filter") {
      let filters = {};
      for (let key of filterFields) {
        if (body[key] !== "") {
          filters[key] = body[key] + "";
        }
      }
      props.getPrizeItemList(filters).then((res) => {
        handleClose();
      });
    } else {
      //before hitting api, check if all validations like mandatory fields are satisfied
      let validatedState = isValidated(body, mandatoryFields);
      let info = body["info"];
      // `info` should be in correct json format
      try {
        if (info === "") {
          info = "null";
        }
        JSON.parse(info);
        info = JSON.stringify(info);
      } catch {
        validatedState = "value of `info` is not in correct JSON format";
      }

      if (validatedState === "validated") {
        props.updatePrizeItem(body).then((res) => {
          let pageRequest = {
            page: currentPage,
          };
          props.getPrizeItemList(activeFilters, pageRequest);
          handleClose();
        });
      } else {
        setStatus({
          type: "error",
          message: validatedState,
        });
      }
    }
  };

  const handleClearFilters = () => {
    props.getPrizeItemList({}).then((res) => {
      props.resetState({ state: "activeFilters" });
      handleClose();
    });
  };

  const handleChange = (key, val) => {
    let values = { ...initialState };
    values[key] = val;
    if (
      key === "item_image" ||
      key === "wheel_image" ||
      key === "win_greet_image"
    ) {
      setActiveImage(val);
    }
    setInitialState(values);
  };

  const isFilterApplicable = (value) => {
    if (modalState === "Filter" && filterFields) {
      return !filterFields.includes(value) ? true : false;
    } else {
      return false;
    }
  };
  const openModal = (src, heading) => {
    setActiveImage(src);
    setImageModalOpen(true);
    setActiveImageHeading(heading);
  };
  const closeModal = () => {
    setImageModalOpen(false);
  };
  const getRequiredButtonPerms = (action = undefined) => {
    if (modalState === "Edit") {
      return [allActions.UPDATE];
    } else if (modalState === "Add") {
      return [allActions.BULK_CREATE];
    }
    return undefined;
  };

  //reset feature list
  useEffect(() => {
    modalState == "Filter"
      ? props.getPrizeItemList({}, { pageSize: 1000 })
      : props.resetState({ state: "prizeItemsList" });
  }, [modalState]);

  useEffect(() => {
    if (activeItem) {
      props.setActivePrizeItem(activeItem);
    }
  }, [activeItem, modalState]);

  useEffect(() => {
    //set the initial state of form in modal
    if (activePrizeItem && modalState === "Edit") {
      let values = { ...initialState };
      Object.keys(values).map((key, idx) => {
        values[key] = activePrizeItem[key]
          ? activePrizeItem[key]
          : getInitialState(initialState, key);
      });

      setInitialState(values);
    }
    if (activeFilters && modalState === "Filter") {
      let values = { ...initialState };
      Object.keys(values).map((key, idx) => {
        values[key] = activeFilters[key] ? activeFilters[key] : "";
      });
      setInitialState(values);
    }
  }, [activePrizeItem, activeFilters]);
  const getModalButtons = () => {
    return (
      <BottomSectionModal className="flex items-center justify-between">
        {modalState === "Filter" && (
          <Button
            data-testid="filterFeatureBtn"
            onClick={handleClearFilters}
            className="sushi-btn"
          >
            Clear
          </Button>
        )}
        <Permission requiredPerms={getRequiredButtonPerms()}>
          <Button
            data-testid="submitButton"
            className="sushi-btn"
            onClick={handleSubmit}
          >
            {modalState === "Filter" ? "Apply" : "Submit"}
          </Button>
        </Permission>
      </BottomSectionModal>
    );
  };

  return (
    <>
      <NoFooterModal
        header={true}
        heading={`${modalState} Prize Item`}
        handleClose={handleClose}
        id="FeatureFormModal"
        modalButtons={getModalButtons()}
      >
        {modalState == "Filter" ? (
          <Autocomplete
            value={initialState.name}
            onChange={(event, newValue) => {
              handleChange("name", newValue);
            }}
            closeIcon={false}
            data-testid="featureName"
            id="controllable-states-demo"
            options={getSortedList(props.prizeItemList, "name")}
            style={{ width: 300 }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Prize Item Name"
                variant="outlined"
              />
            )}
          />
        ) : (
          <Input
            value={initialState.name}
            data-testid="prizeItemName"
            id="sushi-input"
            onChange={(e) => handleChange("name", e)}
            label="Name"
          />
        )}
        {modalState === "Edit" ? (
          <img
            src={initialState.item_image}
            alt="thumbnail"
            style={{ marginBottom: "20px", cursor: "pointer" }}
            onClick={() => openModal(initialState.item_image, "item_image")}
          />
        ) : (
          ""
        )}
        {modalState === "Edit" ? (
          <PaginatedReactDropdown
            options={statusOptions}
            data-testid="featureStatus"
            labelKey="label"
            valueKey="key"
            labelWidth="8%"
            disabled={isFilterApplicable("status")}
            value={initialState.status}
            handleChange={handleChange}
            keyToChange="status"
            placeholder="Status"
            showCross={false}
            id="prizeItemStatusDropdown"
          />
        ) : (
          ""
        )}
        {modalState === "Edit" ? (
          <Input
            value={initialState.info}
            data-testid="prizeItemInfo"
            id="sushi-input"
            onChange={(e) => handleChange("info", e)}
            label="Info"
          />
        ) : (
          ""
        )}
        {modalState === "Edit" ? (
          <Input
            value={getReadableDateTime(initialState.updated_at)}
            data-testid="updated_at"
            id="sushi-input"
            disabled
            label="Updated At"
          />
        ) : (
          ""
        )}
        {modalState === "Edit" ? (
          <Input
            value={getReadableDateTime(initialState.created_at)}
            data-testid="created_at"
            id="sushi-input"
            disabled
            label="Created At"
          />
        ) : (
          ""
        )}
        {modalState === "Edit" ? (
          <PaginatedReactDropdown
            options={categoryOptions}
            data-testid="prizeItemCategory"
            labelKey="label"
            valueKey="key"
            labelWidth="10%"
            disabled={isFilterApplicable("category")}
            value={initialState.category}
            handleChange={handleChange}
            keyToChange="category"
            placeholder="Category"
            showCross={false}
            id="prizeItemStatusDropdown"
          />
        ) : (
          ""
        )}
        {modalState === "Edit" ? (
          <Input
            value={initialState.validity}
            data-testid="prizeItemvalidity"
            id="sushi-input"
            onChange={(e) => handleChange("validity", e)}
            label="Validity"
          />
        ) : (
          ""
        )}
        {modalState === "Edit" ? (
          <div style={containerStyle}>
            <img
              src={initialState.wheel_image}
              alt="First Image"
              style={imageStyle}
              onClick={() => openModal(initialState.wheel_image, "wheel_image")}
            />
            <img
              src={initialState.win_greet_image}
              alt="Second Image"
              style={imageStyle}
              onClick={() =>
                openModal(initialState.win_greet_image, "win_greet_image")
              }
            />
          </div>
        ) : (
          ""
        )}
        {modalState === "Edit" && ImagemodalOpen && (
          <NoFooterModal
            header={true}
            heading={activeImageheading}
            handleClose={closeModal}
            id="Imagemodal"
          >
            <Input
              value={activeImage}
              data-testid="prizeItemImage"
              id="sushi-input"
              onChange={(e) => handleChange(activeImageheading, e)}
              label="Image url"
            />
          </NoFooterModal>
        )}
      </NoFooterModal>
    </>
  );
};
const containerStyle = {
  display: "flex",
  justifyContent: "space-between",
};

const imageStyle = {
  width: "45%",
  height: "auto",
  cursor: "pointer",
};

function mapStateToProps(state) {
  const { PrizeItem } = state;
  return {
    activePrizeItem: PrizeItem.activePrizeItem,
    activeFilters: PrizeItem.activeFilters,
    currentPage: PrizeItem.currentPage,
    prizeItemList: PrizeItem.prizeItemList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updatePrizeItem: bindActionCreators(
      PrizeItemActions.updatePrizeItem,
      dispatch
    ),
    getPrizeItemList: bindActionCreators(
      PrizeItemActions.getPrizeItemList,
      dispatch
    ),
    getPrizeItem: bindActionCreators(PrizeItemActions.getPrizeItem, dispatch),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    resetState: bindActionCreators(PrizeItemActions.resetState, dispatch),
    setActivePrizeItem: bindActionCreators(
      PrizeItemActions.setActivePrizeItem,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PrizeItemFormModal);
